'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _animalInformation = require('./animal-information.component');

var _animalInformation2 = _interopRequireDefault(_animalInformation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.adverseEvent.animal-information', []).component('animalInformation', _animalInformation2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/adverse-event/animal-information/animal-information.module.js